import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Users } from "lucide-react";

export const OwnerFilter = ({ team, value, onChange }) => (
  <div className="flex items-center gap-2">
    <Users className="w-3.5 h-3.5 text-muted-foreground" />
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid="owner-filter-select" className="w-48 h-8 text-xs">
        <SelectValue placeholder="All users" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem data-testid="owner-filter-all" value="all">All users</SelectItem>
        <SelectItem data-testid="owner-filter-unassigned" value="unassigned">Unassigned</SelectItem>
        {team.map((t) => (
          <SelectItem data-testid={`owner-filter-${t.user_id}`} key={t.user_id} value={t.user_id}>{t.name || t.email}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
